import bwipjs from 'bwip-js';

export const generateBarcodePng = (text) => {
  return new Promise((resolve, reject) => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 100;

      bwipjs.toCanvas(canvas, {
        bcid:        'code128',
        text:        text,
        scale:       3,
        height:      10,
        includetext: false,
        paddingwidth: 0,
        paddingheight: 0,
        backgroundcolor: 'FFFFFF'
      });
      const base64 = canvas.toDataURL('image/png');
      resolve(base64);
    } catch (err) {
      reject(err);
    }
  });
};